// extracted by mini-css-extract-plugin
export default {"ExternalLink":"ExternalLink_ExternalLink__njnT3"};